import { Event, events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { reduceProject } from "../../common/project";
import { reduceZone } from "../../common/zone";
import { initialState } from "./initialState";
import { handleRequest } from "./retrieveZonesProjectsRequested";
import { handleSuccess } from "./retrieveZonesProjectsSucceeded";
import { handleFailure } from "./retrieveZonesProjectsFailed";
import { handleProjectCreation } from "./createProjectSucceeded";
import { handleProjectsTransfer } from "./transferProjectsSucceeded";
import { handleProjectRemoval } from "./removeProjectSucceeded";
import { handleZoneRemoval } from "./removeZoneSucceeded";
import { handleUseProjectModel } from "./useProjectModelSucceeded";
import { handleDuplicateProject } from "./useDuplicateProjectSucceeded";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

function propagateEvent(state = initialState, event: Event): State {
  return {
    ...state,
    projects: state.projects.map((project) => ({
      ...reduceProject(project, event),
      zone: reduceZone(project.zone, event),
    })),
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(
    initialState,
    {
      [events.retrieveZonesProjectsRequested]: handleRequest,
      [events.retrieveZonesProjectsSucceeded]: handleSuccess,
      [events.retrieveZonesProjectsFailed]: handleFailure,
      [events.createProjectSucceeded]: handleProjectCreation,
      [events.transferProjectsSucceeded]: handleProjectsTransfer,
      [events.removeProjectSucceeded]: handleProjectRemoval,
      [events.removeZoneSucceeded]: handleZoneRemoval,
      [events.useProjectModelSucceeded]: handleUseProjectModel,
      [events.duplicateProjectSucceeded]: handleDuplicateProject,
    },
    propagateEvent,
  ),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
